import { useContext } from 'react';

import WebAppContext from './WebAppContext';

const useWebApp = () => {
  const context = useContext(WebAppContext);
  if (context === null) {
    throw new Error('useWebApp must be used within a WebAppProvider');
  }
  return context;
};

export default useWebApp;
